// "use strict";

//   const CM_PER_INCH = 2.54;

//   // Metadata keys — every other key in the JSON is looped as a row.
//   const RESERVED = { ages: true, title: true };

//   /**
//    * SizeChart
//    * Renders an interactive, unit-switchable size table from JSON held
//    * in a data attribute. Inch values are the source of truth and are
//    * preserved in memory for lossless inch <-> cm conversion.
//    */
//   class SizeChart {
//     constructor(el, rawJSON, kind) {
//       this.el = el;
//       this.kind = kind; // "girls" | "boys"
//       this.unit = "in"; // default unit
//       this.data = this.parse(rawJSON);
//       if (this.data) {
//         this.render();
//       }
//       console.log(this.data);
//     }

//     /* ----- Static helpers ----- */

//     static round1(n) {
//       return Math.round(n * 10) / 10;
//     }

//     // Convert a base (inch) value to the requested unit, fixed to 1 dp.
//     static toUnit(inchValue, unit) {
//       const v = unit === "cm" ? inchValue * CM_PER_INCH : inchValue;
//       return SizeChart.round1(v).toFixed(1);
//     }

//     // "chest" -> "Chest", "inside_leg" / "inside-leg" -> "Inside Leg"
//     static prettify(key) {
//       return key
//         .replace(/[_-]+/g, " ")
//         .replace(/\b\w/g, (c) => c.toUpperCase());
//     }

//     static escape(str) {
//       const d = document.createElement("div");
//       d.textContent = str == null ? "" : String(str);
//       return d.innerHTML;
//     }

//     /* ----- Parse + validate ----- */

//     parse(rawJSON) {
//       let data;
//       try {
//         data = JSON.parse(rawJSON);
//       } catch (e) {
//         this.fail("Invalid size chart data (malformed JSON).");
//         return null;
//       }
//       // "ages" is the only required field — it supplies the headers.
//       if (!data || !Array.isArray(data.ages) || !data.ages.length) {
//         this.fail('Size chart data must include a non-empty "ages" array.');
//         return null;
//       }
//       return data;
//     }

//     // Build the ordered list of measurement rows from arbitrary keys.
//     rows() {
//       const data = this.data;
//       const cols = data.ages.length;
//       return Object.keys(data)
//         .filter((key) => !RESERVED[key] && Array.isArray(data[key]))
//         .map((key) => ({
//           key,
//           label: SizeChart.prettify(key),
//           values: data[key].slice(0, cols),
//         }));
//     }

//     /* ----- Render ----- */

//     render() {
//       const data = this.data;
//       const rows = this.rows();
//       const title =
//         data.title || "Size Chart";

//       const esc = SizeChart.escape;

//       const headCols = data.ages
//         .map((s) => `<th scope="col">${esc(s)}</th>`)
//         .join("");

//       const bodyRows = rows
//         .map((row) => {
//           const cells = row.values
//             .map((inchVal) => {
//               const num = Number(inchVal);
//               const safe = isFinite(num) ? num : 0;
//               return `<td data-inch="${safe}">${SizeChart.toUnit(
//                 safe,
//                 this.unit,
//               )}</td>`;
//             })
//             .join("");
//           return `<tr><th scope="row">${esc(row.label)}</th>${cells}</tr>`;
//         })
//         .join("");

//       this.el.classList.add("sc");
//       this.el.innerHTML = `
//               <div class="sc__head">
//                 <h2 class="sc__title">${esc(title)}<small>All measurements in <span class="sc__unit-label">inches</span></small></h2>
//                 <div class="sc__toggle" role="group" aria-label="Measurement unit">
//                   <button type="button" data-unit="in" aria-pressed="true">Inches</button>
//                   <button type="button" data-unit="cm" aria-pressed="false">CM</button>
//                 </div>
//               </div>
//               <div class="sc__scroll">
//                 <table class="sc__table">
//                   <thead><tr><th scope="col">Age</th>${headCols}</tr></thead>
//                   <tbody>${bodyRows}</tbody>
//                 </table>
//               </div>
//               <p class="sc__note">Measurements are a guide and may vary by &plusmn;0.5 in. Tip: measure a garment that already fits well and compare.</p>`;

//       // Cache nodes + wire events
//       this.table = this.el.querySelector(".sc__table");
//       this.unitLabel = this.el.querySelector(".sc__unit-label");
//       this.buttons = this.el.querySelectorAll(".sc__toggle button");

//       this.buttons.forEach((btn) => {
//         btn.addEventListener("click", (e) => {
//           this.setUnit(e.currentTarget.getAttribute("data-unit"));
//         });
//       });
//     }

//     /* ----- Unit switching ----- */

//     setUnit(unit) {
//       if (unit === this.unit || (unit !== "in" && unit !== "cm")) return;
//       this.unit = unit;

//       const isIn = unit === "in";
//       this.buttons.forEach((btn) => {
//         const pressed = btn.getAttribute("data-unit") === unit;
//         btn.setAttribute("aria-pressed", String(pressed));
//       });
//       if (this.unitLabel) {
//         this.unitLabel.textContent = isIn ? "inches" : "centimeters";
//       }

//       this.table.classList.add("sc--fading");
//       window.setTimeout(() => {
//         this.table.querySelectorAll("td[data-inch]").forEach((cell) => {
//           const inchVal = parseFloat(cell.getAttribute("data-inch"));
//           cell.textContent = SizeChart.toUnit(inchVal, unit);
//         });
//         this.table.classList.remove("sc--fading");
//       }, 180);
//     }

//     /* ----- Error fallback ----- */

//     fail(msg) {
//       this.el.classList.add("sc");
//       this.el.innerHTML = `<p class="sc__error">⚠ ${SizeChart.escape(msg)}</p>`;
//     }

//     /* ----- Auto-initialise ----- */

//     static init(root) {
//       const scope = root || document;
//       const attrs = [
//         ["data-size-chart-girls", "girls"],
//         ["data-size-chart-boys", "boys"],
//       ];
//       attrs.forEach(([attr, kind]) => {
//         scope.querySelectorAll(`[${attr}]`).forEach((node) => {
//           if (node.__sizeChart) return; // avoid double-init
//           node.__sizeChart = new SizeChart(node, node.getAttribute(attr), kind);
//         });
//       });
//     }
//   }

//   // Expose for manual use (e.g. Shopify section re-renders / AJAX).
//   window.SizeChart = SizeChart;

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", () => SizeChart.init());
//   } else {
//     SizeChart.init();
//   }

//   // Shopify theme editor: re-init when a section is re-rendered.
//   document.addEventListener("shopify:section:load", (e) => {
//     SizeChart.init(e.target);
//   });

(function () {
  "use strict";

  const CM_PER_INCH = 2.54;

  // Metadata keys — every other key in the JSON is looped as a row.
  const RESERVED = { ages: true, title: true };

  /**
   * SizeChart
   * Renders an interactive, unit-switchable size table from JSON held
   * in a data attribute. Inch values are the source of truth and are
   * preserved in memory for lossless inch <-> cm conversion.
   */
  class SizeChart {
    constructor(el, rawJSON, kind) {
      this.el = el;
      this.kind = kind; // "girls" | "boys"
      this.unit = "in"; // default unit
      this.data = this.parse(rawJSON);
      if (this.data) {
        this.render();
      }
    }

    /* ----- Static helpers ----- */

    static round1(n) {
      return Math.round(n * 10) / 10;
    }

    // Convert a base (inch) value to the requested unit, fixed to 1 dp.
    static toUnit(inchValue, unit) {
      const v = unit === "cm" ? inchValue * CM_PER_INCH : inchValue;
      return SizeChart.round1(v).toFixed(1);
    }

    // "chest" -> "Chest", "inside_leg" / "inside-leg" -> "Inside Leg"
    static prettify(key) {
      return key
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
    }

    static escape(str) {
      const d = document.createElement("div");
      d.textContent = str == null ? "" : String(str);
      return d.innerHTML;
    }

    /* ----- Parse + validate ----- */

    parse(rawJSON) {
      let data;
      try {
        data = JSON.parse(rawJSON);
      } catch (e) {
        this.fail("Invalid size chart data (malformed JSON).");
        return null;
      }
      // "ages" is the only required field — it supplies the headers.
      if (!data || !Array.isArray(data.ages) || !data.ages.length) {
        this.fail('Size chart data must include a non-empty "ages" array.');
        return null;
      }
      return data;
    }

    // Build the ordered list of measurement rows from arbitrary keys.
    rows() {
      const data = this.data;
      const cols = data.ages.length;
      return Object.keys(data)
        .filter((key) => !RESERVED[key] && Array.isArray(data[key]))
        .map((key) => ({
          key,
          label: SizeChart.prettify(key),
          values: data[key].slice(0, cols),
        }));
    }

    /* ----- Render ----- */

    render() {
      const data = this.data;
      const rows = this.rows();
      const title =
        data.title || (this.kind === "boys" ? "Size Chart" : "Size Chart");

      const esc = SizeChart.escape;

      const headCols = data.ages
        .map((s) => `<th scope="col">${esc(s)}</th>`)
        .join("");

      const bodyRows = rows
        .map((row) => {
          const cells = row.values
            .map((inchVal) => {
              const num = Number(inchVal);
              const safe = isFinite(num) ? num : 0;
              return `<td data-inch="${safe}">${SizeChart.toUnit(
                safe,
                this.unit,
              )}</td>`;
            })
            .join("");
          return `<tr><th scope="row">${esc(row.label)}</th>${cells}</tr>`;
        })
        .join("");

      this.el.classList.add("sc");
      this.el.innerHTML = `
              <div class="sc__head">
                <h2 class="sc__title">${esc(title)}<small>All measurements in <span class="sc__unit-label">inches</span></small></h2>
                <div class="sc__toggle" role="group" aria-label="Measurement unit">
                  <button type="button" data-unit="in" aria-pressed="true">Inches</button>
                  <button type="button" data-unit="cm" aria-pressed="false">CM</button>
                </div>
              </div>
              <div class="sc__scroll">
                <table class="sc__table">
                  <thead><tr><th scope="col">Age</th>${headCols}</tr></thead>
                  <tbody>${bodyRows}</tbody>
                </table>
              </div>
              <p class="sc__note">Measurements are a guide and may vary by &plusmn;0.5 in. Tip: measure a garment that already fits well and compare.</p>`;

      // Cache nodes + wire events
      this.table = this.el.querySelector(".sc__table");
      this.unitLabel = this.el.querySelector(".sc__unit-label");
      this.buttons = this.el.querySelectorAll(".sc__toggle button");

      this.buttons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          this.setUnit(e.currentTarget.getAttribute("data-unit"));
        });
      });
    }

    /* ----- Unit switching ----- */

    setUnit(unit) {
      if (unit === this.unit || (unit !== "in" && unit !== "cm")) return;
      this.unit = unit;

      const isIn = unit === "in";
      this.buttons.forEach((btn) => {
        const pressed = btn.getAttribute("data-unit") === unit;
        btn.setAttribute("aria-pressed", String(pressed));
      });
      if (this.unitLabel) {
        this.unitLabel.textContent = isIn ? "inches" : "centimeters";
      }

      this.table.classList.add("sc--fading");
      window.setTimeout(() => {
        this.table.querySelectorAll("td[data-inch]").forEach((cell) => {
          const inchVal = parseFloat(cell.getAttribute("data-inch"));
          cell.textContent = SizeChart.toUnit(inchVal, unit);
        });
        this.table.classList.remove("sc--fading");
      }, 180);
    }

    /* ----- Error fallback ----- */

    fail(msg) {
      this.el.classList.add("sc");
      this.el.innerHTML = `<p class="sc__error">⚠ ${SizeChart.escape(msg)}</p>`;
    }

    /* ----- Auto-initialise ----- */

    static init(root) {
      const scope = root || document;
      const attrs = [
        ["data-size-chart-girls", "girls"],
        ["data-size-chart-boys", "boys"],
      ];
      attrs.forEach(([attr, kind]) => {
        scope.querySelectorAll(`[${attr}]`).forEach((node) => {
          if (node.__sizeChart) return; // avoid double-init
          node.__sizeChart = new SizeChart(node, node.getAttribute(attr), kind);
        });
      });
    }
  }

  // Expose for manual use (e.g. Shopify section re-renders / AJAX).
  window.SizeChart = SizeChart;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => SizeChart.init());
  } else {
    SizeChart.init();
  }

  // Shopify theme editor: re-init when a section is re-rendered.
  document.addEventListener("shopify:section:load", (e) => {
    console.log("traget", e.target);
    SizeChart.init(e.target);
  });
})();
